/* Общие примитивы модели Gramps. Вынесены отдельно, чтобы edit.ts и jobs.ts
 * не импортировали друг друга по кругу. */

/** Gramps использует 27-символьный идентификатор объекта. */
export function newHandle(): string {
  const b = new Uint8Array(27)
  crypto.getRandomValues(b)
  return Array.from(b, x => '0123456789abcdef'[x % 16]).join('')
}

/** Следующий свободный номер вида I0068 / E0106. */
export function nextGrampsId(prefix: string, existing: string[]): string {
  const re = new RegExp(`^${prefix}(\d+)$`)
  let max = 0
  for (const id of existing) {
    const m = id?.match(re)
    if (m) max = Math.max(max, Number(m[1]))
  }
  return prefix + String(max + 1).padStart(4, '0')
}

export type DateVal = [number, number, number, boolean]

/** Порядок в dateval — [день, месяц, год, slash]. Проверено: перестановка
 *  день/месяц роняет Gramps с DateError, так что перепутать нельзя. */
export function parseDate(s: string): DateVal | null {
  const t = s.trim()
  if (!t) return null
  let m = t.match(/^(\d{1,2})[.\-/](\d{1,2})[.\-/](\d{4})$/)
  if (m) return [Number(m[1]), Number(m[2]), Number(m[3]), false]
  m = t.match(/^(\d{1,2})[.\-/](\d{4})$/)
  if (m) return [0, Number(m[1]), Number(m[2]), false]
  m = t.match(/^(\d{4})$/)
  if (m) return [0, 0, Number(m[1]), false]
  return null
}

/** Обратно в строку для поля ввода. Ноль в разряде = разряд неизвестен. */
export function formatDate(dv?: DateVal | number[] | null): string {
  if (!dv || dv.length < 3) return ''
  const [d, mo, y] = dv
  if (!y) return ''
  const p = (n: number) => String(n).padStart(2, '0')
  if (d && mo) return `${p(d)}.${p(mo)}.${y}`
  if (mo) return `${p(mo)}.${y}`
  return String(y)
}
